/**
 * File: useTodayPageController.ts
 * Path: apps/admin/src/features/today/hooks/useTodayPageController.ts
 * Description: The Today page's header: today's date, the chosen date range (last 12 months until one is
 * picked), the presets, and whether the Add lead dialog is open.
 */

import { useState } from "react";
import { DEFAULT_YEAR_END_MONTH, southAfricanDay } from "@idk/config";
import { presetRange, type PresetId } from "@/shared/utils/overviewFiguresUtils";
import { BOOKS_START, type DayRange } from "@/features/today/utils/todayOverviewUtils";

export const useTodayPageController = () => {
  const [today] = useState(() => southAfricanDay(Date.now()));
  const presets = (id: PresetId) => presetRange(id, today, DEFAULT_YEAR_END_MONTH, BOOKS_START);
  const [chosen, setChosen] = useState<DayRange | null>(null);
  const range = chosen ?? presets("last12");
  const [adding, setAdding] = useState(false);

  return {
    today,
    range,
    presets,
    setRange: setChosen,
    adding,
    setAdding,
    openAddLead: () => setAdding(true),
  };
};
